import { useState, useEffect } from 'react'

export const useFetch = (url, options) => {
  const [response, setResponse] = useState(null)
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    const { abortController: { aborted, abort } = {} } = new AbortController()
    const doFetch = async () => {
      setLoading(true)
      try {
        const res = await fetch(url, options)
        const json = await res.json()
        if (!aborted) {
          setResponse(json)
        }
      } catch (e) {
        if (!aborted) {
          setError(e)
        }
      } finally {
        if (!aborted) {
          setLoading(false)
        }
      }
    }
    doFetch()
    return abort
  }, [])
  return { response, error, loading }
}
